// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UserService } from '@daml.js/utility-credential-app-v0/lib/Utility/Credential/App/V0/Service/User';
import { ERR_REV_CRED, SUC_REV_CRED } from '../../../utils/strings';
import { useExerciseSubmission } from '../ledger/useSubmission';

const useRevokeCredential = () => {
  const { submit } = useExerciseSubmission(
    UserService.UserService_RevokeCredential,
    SUC_REV_CRED,
    ERR_REV_CRED,
  );

  return submit;
};

export default useRevokeCredential;
